var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`info-banner-container ${_vm.color}`},[_c('v-icon',{staticClass:"info-icon"},[_vm._v(_vm._s(_vm.iconName))]),_c('p',{directives:[{name:"sanitize-html",rawName:"v-sanitize-html",value:(_vm.message),expression:"message"}],on:{"click":_vm.clickOnLink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }